export default {
	methods: {
		openTrialExpiredDialog () {
			this.$store.dispatch('setShowExpirationDialog', true)
		}
	}
}
